export function cookieListeners() {
  if (getCookie('cookie_notice') == '') {
    const cookieContainer = document.getElementById('cookie-notice');
    const cookieOverlay = document.getElementById('cookie-overlay');

    if (cookieContainer && cookieOverlay) {
      showNotice(cookieContainer, cookieOverlay);
    }

    const cookieOk = document.getElementById('cookie-notice-akkoord');
    if (cookieOk) {
      cookieOk.addEventListener('click', () => {
        setCookie('cookie_notice', 'ok', 365);
        hideNotice(cookieContainer, cookieOverlay);
      });
    }

    const cookieClose = document.getElementById('cookie-notice-close');
    if (cookieClose) {
      cookieClose.addEventListener('click', () => {
        setCookie('cookie_notice', 'not_ok');
        hideNotice(cookieContainer, cookieOverlay);
      });
    }
  }
}

function setCookie(key, value, days = 1) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
    key +
    '=' +
    value +
    '; expires=T' +
    date.toUTCString() +
    ';  path=/;SameSite=Strict;';
}

function showNotice(cookieContainer, cookieOverlay) {
  cookieContainer.classList.remove('translate-y-full');
  cookieContainer.classList.remove('opacity-0');
  // cookieOverlay.classList.remove("opacity-0");
  // cookieOverlay.classList.remove("pointer-events-none");
}

function hideNotice(cookieContainer, cookieOverlay) {
  cookieContainer.classList.add('translate-y-full');
  cookieContainer.classList.add('opacity-0');
  cookieOverlay.classList.add('opacity-0');
  cookieOverlay.classList.add('pointer-events-none');
}

function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
